import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import {
  Response,
  LoginRequest,
  LoginResponse,
  PasswordRequest,
  RefreshTokenRequest,
  QueryRequest,
  LogoutResponse,
  PasswordResponse,
  LoginByCertificateRequest,
  CheckDomainRequest,
  LoginByTokenRequest
} from '@models/index.model';
import { UtilsService } from '@utils/utils.service';

@Injectable()
export class AuthService {
  private UrlAPI = environment.apiAuthUrl;

  constructor(private http: HttpClient, private _utils: UtilsService) {}

  public logIn(loginRequest: LoginRequest): Observable<Response<LoginResponse>> {
    const query = this.UrlAPI + QueryRequest.authLogin;
    return this.http.post<Response<LoginResponse>>(query, this._utils.stringifyData(loginRequest));
  }

  public changePassword(passwordRequest: PasswordRequest): Observable<Response<PasswordResponse>> {
    const query = this.UrlAPI + QueryRequest.authPassword;
    return this.http.put<Response<PasswordResponse>>(query, this._utils.stringifyData(passwordRequest));
  }

  public loginByCertificate(loginByCertificateRequest: LoginByCertificateRequest): Observable<Response<LoginResponse>> {
    const query = this.UrlAPI + QueryRequest.authLoginByCertificate;
    return this.http.post<Response<LoginResponse>>(query, this._utils.stringifyData(loginByCertificateRequest));
  }

  public loginByToken(loginByTokenRequest: LoginByTokenRequest): Observable<Response<LoginResponse>> {
    const query = this.UrlAPI + QueryRequest.authLoginByToken;
    return this.http.post<Response<LoginResponse>>(query, this._utils.stringifyData(loginByTokenRequest));
  }

  public refreshToken(refreshTokenRequest: RefreshTokenRequest): Observable<Response<LoginResponse>> {
    const query = this.UrlAPI + QueryRequest.authRefreshToken;
    return this.http.put<Response<LoginResponse>>(query, this._utils.stringifyData(refreshTokenRequest));
  }

  public logout(): Observable<Response<LogoutResponse>> {
    const query = this.UrlAPI + QueryRequest.authLogout;
    return this.http.delete<Response<LogoutResponse>>(query);
  }

  public checkDomain(checkDomainRequest: CheckDomainRequest): Observable<Response<string>> {
    const query = this.UrlAPI + QueryRequest.authCheckDomain;
    return this.http.post<Response<string>>(query, this._utils.stringifyData(checkDomainRequest));
  }

  public echoping(): Observable<boolean> {
    const query = this.UrlAPI + QueryRequest.authEchoPing;
    return this.http.get<boolean>(query);
  }
}
